'use client'

import classNames from 'classnames'

export function ScrollLinkV2({ plainText, identifier, variantClass, classNameOverride, ...props }) {
  const handleScrollClick = () => {
    const el = document.querySelector(`[data-scrolto="${identifier}"]`)
    if (el) {
      window.scrollTo({
        top: el.offsetTop - 70,
        behavior: 'smooth',
      })
    }
  }

  return (
    <a
      role="button"
      tabIndex={0}
      className={classNames('cursor-pointer underline', variantClass, classNameOverride)}
      data-testid={`Scroll-to-${plainText}`}
      onClick={handleScrollClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') handleScrollClick()
      }}
      aria-label={`Scroll to ${plainText}`}
      {...props}
    >
      {plainText}
    </a>
  )
}

export function ScrollToMarkerV2({ identifier }) {
  return <span data-scrolto={identifier} />
}
